// store/applicationDraft.slice.ts
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiCandidateAddPublic } from './applicationDraft.service'

const initialState = {
    overview: {}, // name, email, phone, address, etc. (optional, if you want)
    education: [], // array of education entries staged in UI
    experience: [], // if you have experience entries
    resumeDraft: { url: null, fileType: null, fileName: null },
    profileImageFile: null, // raw File
    profileImageUrl: null, // uploaded URL (optional, can upload at submit)
}

export const AddCandidatePublic = createAsyncThunk(
    'applicationDraftSlice/create',
    async (payload = {}) => {
        const response = await apiCandidateAddPublic(payload)
        return response
    }
)

const applicationDraftSlice = createSlice({
    name: 'applicationDraftSlice',
    initialState,
    reducers: {
        setOverviewDraft: (state, { payload }) => {
            state.overview = { ...state.overview, ...payload }
        },
        setEducationDraft: (state, { payload }) => {
            state.education = payload // or push for add/edit/remove, up to your UI
        },
        addEducationDraft: (state, { payload }) => {
            state.education.push(payload)
        },
        updateEducationDraft: (state, { payload }) => {
            const { _tempId, data } = payload
            state.education = state.education.map((e) =>
                e._tempId === _tempId ? { ...e, ...data } : e
            )
        },
        removeEducationDraft: (state, { payload }) => {
            state.education = state.education.filter(
                (e) => e._tempId !== payload
            )
        },
        setExperienceDraft: (state, { payload }) => {
            state.experience = payload // or push for add/edit/remove, up to your UI
        },
        addExperienceDraft: (state, { payload }) => {
            state.experience.push(payload)
        },
        updateExperienceDraft: (state, { payload }) => {
            const { id, data } = payload
            state.experience = state.experience.map((e) =>
                e._id === id ? { ...e, ...data } : e
            )
        },
        removeExperienceDraft: (state, { payload }) => {
            state.experience = state.experience.filter((e) => e._id !== payload)
        },
        setResumeDraft: (state, { payload }) => {
            state.resumeDraft = payload // {url, fileType, fileName}
        },
        setProfileImageFile: (state, { payload }) => {
            state.profileImageFile = payload // File
        },
        setProfileImageUrl: (state, { payload }) => {
            state.profileImageUrl = payload // uploaded URL
        },
        clearDraft: () => initialState,
    },
})

export const {
    setOverviewDraft,
    setEducationDraft,
    addEducationDraft,
    updateEducationDraft,
    removeEducationDraft,
    setResumeDraft,
    setProfileImageFile,
    setProfileImageUrl,
    clearDraft,
    setExperienceDraft,
    addExperienceDraft,
    updateExperienceDraft,
    removeExperienceDraft,
} = applicationDraftSlice.actions

export default applicationDraftSlice.reducer
